<div class="container text-center">
  <h3>Aktivierung</h3>
  <p><i>Diese Seite leitet Sie nach der Aktivierung zum Login weiter.</i></p>
</div>
